import { withRouter } from "react-router";
import Background from "../components/Background";
import NavTopBar from "../components/NavTopBar";
import Footer from "../components/Footer";
import PublisherSalesPanel from "../components/PublisherSalesPanel";

const LibraryStatsView = ({ history }) => {
  return (
    <>
      <NavTopBar />
      <Background height="45vh" />
      <PublisherSalesPanel />
      <Footer />
    </>
  );
};

export default withRouter(LibraryStatsView);
